/**
 * Волна A (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/warranty'>.
 * Сужение не-exact → exact, как и /about.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Guarantee from '@routes/StaticPages/Guarantee';

export const Route = createFileRoute('/warranty')({
  component: () => <CacheDataRoute component={Guarantee} path='/warranty' />
});
